<template>
  <div class="info-tooltip-container" @mouseenter="showTip" @mouseleave="showTip">
    <slot name="tooltip-trigger">
      <inline-svg class="info-icon" :src="require('@ui-kit/assets/images/general/info.svg')">
      </inline-svg>
    </slot>
    <div
      class="info-content-box t4"
      :class="{'b': position === 'bottom',
               't': position === 'top', 'box-hidden': visible === false}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'infoTooltip',
  props: {
    position: {
      type: String,
      default: 'bottom',
    },
  },
  data() {
    return { visible: null };
  },
  methods: {
    showTip(e) {
      e.stopPropagation();
      this.visible = !this.visible;
    },
  },
};
</script>

<style lang="scss" scoped>
  $information-icon-side: 1.25rem;
  $content-fade-duration: 0.3s;
  $offset-from-container: 0.5rem;
  $relative-arrow-position: calc((100% - #{$offset-from-container}) - #{1.25rem}); // 1.5rem from right side
  $info-arrow-size: 6px;
  $info-box-padding: 0.625rem;

  .info-tooltip-container {
    height: $information-icon-side;

    svg.info-icon {
      width: $information-icon-side;
    }

    &:hover {
      cursor: pointer;

      .info-content-box {
        opacity: 1;
        visibility: visible;
        transition: visibility 0s, opacity $content-fade-duration linear;
      }
    }
  }

  .info-content-box {
    position: absolute;
    border-radius: 0.5rem;
    background-color: white;
    padding: $info-box-padding;
    box-shadow: $default-shadow-wuk;
    min-width: 120px;
    max-width: calc(100% - #{$offset-from-container * 2});
    opacity: 0;
    visibility: hidden;
    z-index: 1;

    &.box-hidden {
      transition: visibility $content-fade-duration, opacity $content-fade-duration linear;
    }

    &.b {
      top: 3rem;
      left: auto;
      right: $offset-from-container;
      transform: none;
      @include bubble-arrow(top, white, $relative-arrow-position);
    }

    &.t {
      top: -6px;
      transform: translate(-50%, calc(-100% - #{$info-arrow-size}));
      @include bubble-arrow(bottom, white, $relative-arrow-position);
    }
  }
</style>
